module.exports = __webpack_public_path__ + "img/logo-bt.00ccd4fb.svg";